import React from 'react'
import { connect } from 'react-redux'
import AlbumName from './views/albums/name'
import Photo from './views/albums/photo'

class FavoriteAlbum extends React.Component {

  render () {
    const { photos, title } = this.props

    if (photos.length == 0) { return null }

    return (
      <div className="album" id="favorite_album">
        <AlbumName title={title} id="favorite_album_name" />
        <div className="gallery">
          { photos.map((photo) => <Photo key={photo.id} 
              {...photo} 
              albumTitle={this.props.title} 
              favorite= {false} 
            />            
          )}
        </div>
      </div>
    )
  }
}

export default connect((state, props) => {
  const favoritePhotos = props.uploaderIds.reduce((result, uploaderId) => {
    const files = state.uploader?.[uploaderId]?.files || []
    const favoriteFiles = files.filter(f => f.favorite?.enabled)
    result = result.concat(favoriteFiles)
    return result
  }, [])

  return ({
    title: props.title,
    photos: favoritePhotos
  })
}, {})(FavoriteAlbum)
